export default "/static/featured/expert.jpg"